import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  clearAuthSession,
  revokeRefreshToken,
  saveSessionRedirectPath,
} from "../../constants/authSession";

function Logout({ history, sessionExpired = false }) {
  useEffect(() => {
    // Read the tokens before they are cleared; the request itself is fire-and-forget.
    revokeRefreshToken();
    if (sessionExpired) {
      saveSessionRedirectPath();
      clearAuthSession(true);
      window.location.reload();
    } else {
      clearAuthSession(false);
      history.replace("/");
      window.location.reload();
    }
  }, [history, sessionExpired]);

  return null;
}

export default withRouter(Logout);
